import { render } from "./App.vue?vue&type=template&id=bee6529c&ts=true&lang=pug"
import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=bee6529c&lang=scss"

import exportComponent from "/home/runner/work/affolterNET.Tickets/affolterNET.Tickets/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__